import { render, staticRenderFns } from "./BreadCrumbEvent.vue?vue&type=template&id=ae72bdd6&scoped=true"
import script from "./BreadCrumbEvent.vue?vue&type=script&lang=js"
export * from "./BreadCrumbEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae72bdd6",
  null
  
)

export default component.exports